import { render, staticRenderFns } from "./articleView.vue?vue&type=template&id=d10c196c&scoped=true&"
import script from "./articleView.vue?vue&type=script&lang=js&"
export * from "./articleView.vue?vue&type=script&lang=js&"
import style0 from "./articleView.vue?vue&type=style&index=0&id=d10c196c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10c196c",
  null
  
)

export default component.exports